import Vue from 'vue'
import VueRouter from 'vue-router'
// import layout from '@/components/layout/index.vue'

// import integratedData from '@/views/integratedData/index.vue'
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [{
	path: '/',
	// component: () => import('../views/index.vue')
	meta: {
		title: '首页'
	},
	component: () => import( /* webpackChunkName: "home" */ '@/views/index.vue'),
	redirect: '',
	children: [
		
		{
			path: 'home',
			name: 'Home',
			meta: {
				title: '首页'
			},
			component: () => import( /* webpackChunkName: "home" */
				'@/views/home/home.vue')
		},
		
		
		
	]
}]
const router = new VueRouter({
	//mode: 'history',
	routes
})

export default router